import EntrepriseMarcheInfosDto from "./EntrepriseMarcheInfosDto";

export default class EmpreinteEconomiqueDto {
  id;
  entrepriseMarcheInfos = new EntrepriseMarcheInfosDto();
  nature;
  sousTraitantId;
  rangSousTraitant;
  objetPrestation;
  categoriePrestation;
  categoriePrestationAutre;
  datePremiereCommande;
  dc4;
  montantMarche;
  montantPmeEntreprise;
  commentaire;
  statut;
  jourSoumissionPassed;
  date;
  numeroIdentification;
  createdDate;
  mdm;
  pieceJustificative;
  user;
}
